var _circle, _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNemaPorucivanjaImg = function SvgNemaPorucivanjaImg(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 121,
    viewBox: "0 0 121 121",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 60.5,
    r: 60.5,
    fill: "#00B2B1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.8361 45.0143C67.5095 45.0143 57.7966 45.0143 70.8691 45.0143C83.9412 45.0143 87.5227 45.0143 83.9412 62.8043C80.5039 79.8776 81.5012 79.7 65.3935 79.6323C64.4847 79.6285 60.2715 79.625 59.25 79.625C39.75 79.625 42.4867 77.949 38.2063 59.1971C32.8542 35.75 36.4016 35.75 23.5 35.75",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.8752 88.8877C45.8109 88.8877 44.1377 90.5613 44.1377 92.6252C44.1377 94.6891 45.8109 96.3627 47.8752 96.3627C49.9395 96.3627 51.6127 94.6891 51.6127 92.6252C51.6127 90.5613 49.9395 88.8877 47.8752 88.8877ZM77.1252 88.8877C75.0612 88.8877 73.3877 90.5612 73.3877 92.6252C73.3877 94.6892 75.0612 96.3627 77.1252 96.3627C79.1892 96.3627 80.8627 94.6892 80.8627 92.6252C80.8627 90.5612 79.1892 88.8877 77.1252 88.8877Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0373 100.85L108 20.5003",
    stroke: "white",
    strokeWidth: 3
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNemaPorucivanjaImg, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/nema_porucivanja_img.2b2fe6a9.svg";
export { ForwardRef as ReactComponent };